import { Capacitor } from '@capacitor/core';

export async function openExternal(url) {
  if (Capacitor.isNativePlatform()) {
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url });
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}

export const TERMS_URL = 'https://recall.wolftechnologies.co.uk/terms.html';
export const PRIVACY_URL = 'https://recall.wolftechnologies.co.uk/privacy.html';
